import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Button, Upload, Space, Spin } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ErrorFallback from "./ErrorFallback";
import queryString from "query-string";
import { useCreateRouteManifestMutation } from "../app/services/taxy";
import { parseRouteManifestCSV } from "../helpers/routeManifestParser";

const CreateRouteManifest = ({ openNotificationWithIcon }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [errorList, setErrorList] = useState([]);

  const createRouteManifestRequests = useRef([]);
  const routeManifestData = useRef([]);

  const [routeManifestFileList, setRouteManifestFileList] = useState([]);

  const { authToken, clientId } = queryString.parse(location.search);

  const [
    createRouteManifest,
    {
      isLoading: isUploading,
      data: createRouteManifestData,
      error: createRouteManifestError,
      isError: iscreateRouteManifestError,
      isSuccess: iscreateRouteManifestuccess,
    },
  ] = useCreateRouteManifestMutation();

  useEffect(() => {
    if (iscreateRouteManifestuccess) {
      routeManifestData.current = createRouteManifestData;
    }
  }, [
    isUploading,
    createRouteManifestData,
    iscreateRouteManifestuccess,
    createRouteManifestError,
    iscreateRouteManifestError,
  ]);

  // Redirect to Order Creation Success page
  useEffect(
    () => {
      if (iscreateRouteManifestuccess) {
        openNotificationWithIcon(
          "success",
          "Route Manifests Updated Success.",
          `Total routes updated are ${createRouteManifestRequests.current.length}`
        );
        resetFiles();
      }
    }, //eslint-disable-next-line
    [iscreateRouteManifestuccess]
  );

  const getCustomError = (errorData) => {
    return errorData;
  };

  // Redirect to unauthorized page if user is not authenticated
  useEffect(() => {
    if (!iscreateRouteManifestError) return;

    if (createRouteManifestError.status === 401) navigate("/unauthorized");
    else if (createRouteManifestError.status === 422) {
      const errorData = createRouteManifestError?.data?.message || [];
      const customError = getCustomError(errorData);

      setErrorList(["Some Error occured", customError]);
    } else if (
      createRouteManifestError.status >= 400 &&
      createRouteManifestError.status <= 599
    ) {
      setErrorList([
        "Some Error occured",
        createRouteManifestError?.data?.data?.message ||
          createRouteManifestError?.data?.message,
      ]);
    }
  }, [
    iscreateRouteManifestError,
    createRouteManifestError,
    navigate,
    location,
  ]);

  const resetFiles = () => {
    setRouteManifestFileList([]);
  };

  const onSubmit = async () => {
    try {
      let { data } = await parseRouteManifestCSV(
        routeManifestFileList[0],
        clientId
      );
      createRouteManifestRequests.current = data.createRouteManifestRequests;
      await createRouteManifest({
        clientId,
        authToken,
        requestBody: createRouteManifestRequests.current,
      });
    } catch (data) {
      const { errors } = data;
      setErrorList([...errorList, errors]);
    }
  };

  const routeManifestFileOptions = {
    multiple: false,
    accept: "text/csv",
    routeManifestFileList,
    onRemove: (file) => {
      const index = routeManifestFileList.indexOf(file);
      const newFileList = routeManifestFileList.slice();
      newFileList.splice(index, 1);
      setErrorList([]);
      return setRouteManifestFileList(newFileList);
    },
    beforeUpload: (files) => {
      setErrorList([]);
      setRouteManifestFileList([files]);
      return false;
    },
  };

  if (
    errorList !== null &&
    errorList !== undefined &&
    Array.isArray(errorList) &&
    errorList.length > 0
  ) {
    return (
      <ErrorFallback
        errorData={errorList}
        cb={() => setErrorList([])}
        cbBtnName="Upload Again"
        title="Upload Failed"
      />
    );
  }

  function shouldDisableButton() {
    return !(routeManifestFileList.length === 1);
  }

  return (
    <div>
      <Row justify="center" style={{ paddingTop: "30px" }}>
        <Space size="large" direction="vertical" align="center">
          <Upload {...routeManifestFileOptions}>
            <Button style={{ width: 350 }} icon={<UploadOutlined />}>
              Select Manifest File
            </Button>
          </Upload>
          <Button
            style={{ width: 350, marginBottom: "30px" }}
            type="primary"
            disabled={shouldDisableButton()}
            onClick={onSubmit}
          >
            Submit
          </Button>
          {((isUploading && !iscreateRouteManifestuccess) ||
            (isUploading && iscreateRouteManifestError)) && (
            <Spin tip="Please wait, Processing..." />
          )}
        </Space>
      </Row>
    </div>
  );
};

export default CreateRouteManifest;
